import Model from './Model'
export default class Role extends Model {

    resource()
    {
        return 'permissions'
    }
}
